import { AxiosResponse } from 'axios';
import React, { useEffect } from 'react';


export type SearchConditionsResponseItemLabel = {
  key?: string; // "4009"
  label: string; // "默认地区"
  title?: string; //  "默认地区"
  value: string|number; //  "4009"
  children?: SearchConditionsResponseItem[];
};

export type SearchConditionsResponseItem = SearchConditionsResponseItemLabel;

// 公用筛选数据统一配置
export type SearchConditionsParams = Partial<{
  stock: (
    | 'available_inventory'
    | 'inventory'
    | 'in_status'
    | 'in_type' //入库
    | 'out_type' //出库
    | 'in_out'
  )[];
  client: (
    | 'type'
    | 'new_area'
    | 'new_status'
    | 'tag'
    | 'clearing_form'
    | 'pay_type'
  )[];
  purchase: (
    | 'stock'
    | 'status'
    | 'pay_status'
    | 'category'
    | 'stockCollaborator'
  )[];
  goods: (
    | 'list_type'
    | 'category'
    | 'brand'
    | 'brand_filter_permission'
    | 'goods_type'
    | 'supplier'
    | 'translation'
    | 'hasPicture'
    | 'hasOfferPrice'
    | 'putaway'
    | 'split_type'
  )[];
  payment: ('status' | 'way' | 'type')[];
  order: (
    | 'status'
    | 'admin_order'
    | 'orders_type'
    | 'pay_status'
    | 'source_device'
    | 'delivery_status'
    | 'status_delivery'
  )[];
  transfer: ('stock_id' | 'staff_id' | 'transfer_status' | 'review_status')[];
  collaborator: ('list' | 'list_filter')[];
  add_warehouse: ('warehouse_type' | 'customer_sort')[];
  staff: 'branch'[];
  affiliate_situation: Array<'putaway'|'company'|'brand'|'stock'|'category'>//通过联营商查询相关运营商的提供的商品信息之类
}>;

export type SearchConditionsResponse<T extends SearchConditionsParams> = {
  // [conditionType in keyof T]: {
  //   [conditionTypeSub in T[conditionType] extends Array<string> ? T[conditionType][number] : never]: SearchConditionsResponseItem[];
  // };
  [conditionType in keyof T]: conditionType extends 'affiliate_situation'
  ? ([T['affiliate_situation']] extends [Array<infer P>]  ?  {  [key in P extends string ? P :never ]: key extends 'stock'|'brand'|'category' ? {[companyId in number]: SearchConditionsResponseItem[] }: SearchConditionsResponseItem[] }   : never  ) : 
  //  ? ([T['affiliate_situation']] extends [Array<infer P>]  ? P extends 'stock' ? {stock:{ number: SearchConditionsResponseItem}}: {  }: never  ) : 
   {  [conditionTypeSub in T[conditionType] extends Array<string> ? T[conditionType][number] : never]: SearchConditionsResponseItem[]; };
  }; 

const convertData = (
  value: object[],
  options?: { labelField: string; valueField: string },
) => {
  let { labelField = 'label', valueField = 'value' } = options || {};
  return (value = value.map((item: any) => {
    if (Object.keys(item).length == 2) {
      let key = item.key;
      let value = item.value;
      if ((key !== undefined) && value) {
        return {
          key,
          label: value,
          value: key,
        };
      }
    }
    let lable = item[labelField] || item.name;
    let value = item[valueField] || item.id;
    return {
      ...item,
      label: lable,
      value: value,
    };
  }));
};

function mergeData(targetData: any, sourceData: any) {
  for (let key in sourceData) {
    let subSourceData = sourceData[key];
    let subTargetData = (targetData[key] = targetData[key] || {});
    for (let subKey in subSourceData) {
      let value = subSourceData[subKey];
      if (key == 'purchase') {
        if (['status', 'pay_status'].includes(subKey)) {
          value = convertData(value, {
            labelField: 'title',
            valueField: 'name',
          });
        }
        if (['stock', 'stockCollaborator'].includes(subKey)) {
          value = convertData(value, {
            labelField: 'stock_name',
            valueField: 'stock_id',
          });
        }
      }
      if(key == 'affiliate_situation'){
        if(['stock','brand',].includes(subKey)){
          let stockValues:{[companyId:string]:any} = {}
          Object.keys(value).forEach((companyId:string)=>{
            stockValues[companyId] =  convertData(value[companyId])
          })
          subTargetData[subKey] = stockValues;
          continue
        }
        if(['category'].includes(subKey)){
          subTargetData[subKey] = value;
          continue
        }
      }
      if (!Array.isArray(value)) {
        value = Object.keys(value).map((key) => {
          return {
            label: value[key],
            value: key,
          };
        });
      } else {
        value = convertData(value);
      }
      subTargetData[subKey] = value;
    }
  }
  return targetData;
}
const getEmptyCondition = (
  targetData: { [x: string]: { [y: string]: any } },
  sourceData: { [x: string]: string[] },
) => {
  let newSourceData = { ...sourceData };
  for (let key in newSourceData) {
    let subSourceData = newSourceData[key];
    let subTargetData = targetData[key];
    if (subTargetData) {
      let newSubSourceData: string[] = [];
      subSourceData.forEach((item) => {
        if (!subTargetData[item]) {
          newSubSourceData.push(item);
        }
      });
      if (newSubSourceData.length) {
        newSourceData[key] = newSubSourceData;
      }
    }
  }
  return newSourceData;
};
export const useSearchCondition = <T extends SearchConditionsParams>(
  conditionParams: T,
  options:{
    manual?: boolean,  //默认点击时触发，如果需要加载时触发，改为false
    serviceSearchConditions: (conditionParams:T)=>Promise<AxiosResponse<AxiosHttpPromise<SearchConditionsResponse<T>>>>,
    isError(res:any): boolean
  },
) => {
  const { manual = true,serviceSearchConditions,isError} = options
  const [searchCondition, setSearchCondition] = React.useState<
    Partial<SearchConditionsResponse<T>>
  >({});
  const [loading, setLoding] = React.useState<boolean>(false);
  const [isFirstFocus, setIsFirstFocus] = React.useState<boolean>(true);

  const getConditions = async () => {
    setLoding(true)

    let res = await serviceSearchConditions(conditionParams);
    if (isError(res)) {
      return;
    }
    setLoding(false)
    let data = res.data.data;
    let newSearchCondition = { ...searchCondition };
    let newData = mergeData(newSearchCondition, data);
    // console.log(mergeData(newSearchCondition, data),"mergeData");
    
    setSearchCondition(newData);
  };
  useEffect(() => {
    if(!manual){
      getConditions();
    }
  }, []);
  const getInitData = ()=>{
    if(isFirstFocus){
      setIsFirstFocus(false)
      getConditions()
    }
  }
  
  return {
    searchCondition,
    getInitData,
    loading
  };
};